import { useQuery } from "@tanstack/react-query";
import {
  StructuredRelatedCompanyDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_COMPANIES } from "../domain";

import { companiesApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_COMPANIES_STRUCTURE = "GET_COMPANIES_STRUCTURE";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const getCompaniesStructure = async (): Promise<StructuredRelatedCompanyDto> => {
  const response = await companiesApi.companiesControllerGetCompaniesStructure();

  return response.data;
};

export const useGetCompaniesStructure = (
  user: UserProfileDto | null,
): {
  companiesStructure?: StructuredRelatedCompanyDto;
  companiesStructureEnabled: boolean;
  isPendingGetCompaniesStructure: boolean;
  refetchCompaniesStructure: () => void;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { data, isPending, refetch } = useQuery({
    queryKey: [DOMAIN_COMPANIES, ACTION_GET_COMPANIES_STRUCTURE],
    queryFn: () => getCompaniesStructure(),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    companiesStructure: data,
    companiesStructureEnabled: enabled,
    isPendingGetCompaniesStructure: isPending,
    refetchCompaniesStructure: refetch,
  };
};
